module.exports = __webpack_public_path__ + "img/4.1d341af3.jpg";